import { useEffect, useState } from "react";
import { url } from "../utils/config";
import Table from "../reusable_components/Table";
import Button from "../reusable_components/Button";
import { title, btnOneNoWidth } from "../utils/style";
import AddFleetCustomer from "../modals/AddFleetCustomer";
import edit from "../assets/icons/edit.png";
import deleteIcon from "../assets/icons/delete.png";
import ConfirmationModal from "../reusable_components/ConfirmationModal";
import { toast } from "react-toastify";
import axios from "axios";
import formatNumberToUs from "../custom_functions/formatNumberToUs";
import AddFleetCar from "../modals/AddFleetCar";
import fetchData from "../custom_functions/fetchData";
import ImportModal from "../reusable_components/ImportModal";
import * as XLSX from "xlsx";
import postData from "../custom_functions/postData";

function Fleet() {
  const [showAddFleet, setShowAddFleet] = useState(false);
  const [reloadTable, setReloadTable] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [otherData, setOtherData] = useState();
  const [viewData, setViewData] = useState(null);
  const [cars, setCars] = useState([]);
  const [countryConfig, setCountryConfig] = useState([]);
  const [showImportModal, setShowImportModal] = useState(false);
  const [importRowLimit, setImportRowLimit] = useState(200);


  async function getGlobalConfig() {
    fetchData(
      url + "/global_config",
      (error) => {
        toast.error(error.response.data.message, { autoClose: 3000 });
      },
      (data) => {
        // Find importRowsLimit and set it
        const limitObj = data.data.find(item => item.name === "importRowsLimit");
        if (limitObj) {
          setImportRowLimit(Number(limitObj.value));
        }
      }
    );
  }

  useEffect(() => {
    getCars();
    getCountryConfig();
    getGlobalConfig();
  }, []);

  async function getCountryConfig() {
    fetchData(
      url + "/country_config",
      (error) => {
        toast.error(error.response.data.message, { autoClose: 3000 });
      },
      (data) => {
        setCountryConfig(data.data);
      }
    );
  }


  async function getCars() {
    fetchData(
      url + "/car_list",
      (error) => {
        toast.error(error.response.data.message, { autoClose: 3000 });
      },
      (data) => {
        setCars(data.data);
      }
    );
  }

  function handleFileUpload(file) {
    if (!file) return;

    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });
        if (jsonData.length == 0) {
          return toast.error("File is empty", { autoClose: 3000 })
        }
        if (jsonData.length > 100) {
          return toast.error("File can only have upto 100 records", { autoClose: 3000 })
        }

        postData(
          `${url}/import_fleet_customer`,
          { data: jsonData, countryConfig },
          (error) => {
            toast.error(error.response.data.message, { autoClose: 3000 });
          },
          (data) => {
            const { insertCount, updateCount, faildCount, errorResult } = data;
            toast.info(
              `Import Result\n` +
              `Record Created : ${insertCount}\n` +
              `Record Updated : ${updateCount}\n` +
              `Record Failed  : ${faildCount}`,
              {
                autoClose: 3000,
                style: { whiteSpace: "pre-line" },
              }
            );
            if (errorResult.length > 0) {
              const ws = XLSX.utils.json_to_sheet(errorResult);
              const wb = XLSX.utils.book_new();
              XLSX.utils.book_append_sheet(wb, ws, "Failed_Records");
              XLSX.writeFile(wb, "Import_Errors.xlsx");
            }
            setReloadTable((prev) => !prev);
          }
        );

      } catch (err) {
        console.error("Error reading Excel file:", err);
      }
    };

    reader.onerror = (err) => {
      console.error("FileReader error:", err);
    };

    reader.readAsArrayBuffer(file);
  }


  const downloadExcel = () => {
    const headers = [
      "name",
      "company_name",
      "email",
      "phone",
      "mobile",
      "address_line1",
      "address_line2",
      "city",
      "state_province",
      "postal_code",
      "country",
      "preferred_contact_method",
      "creditLimit",
      "paymentTerms",
      "maxDiscount",
      "bypassApproval",
      "notes",
      "custom_field_1",
      "custom_field_2",
      "custom_field_3"
    ];

    const ws = XLSX.utils.aoa_to_sheet([headers]);
    const colWidths = headers.map(() => ({ wch: 20 }));
    ws['!cols'] = colWidths;
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "FleetCustomers");
    XLSX.writeFile(wb, "fleet_customer_template.xlsx");
  };

  function toggleModify(data) {
    setOtherData(data);
    setShowAddFleet(true);
  }

  async function deleteFleet() {
    try {
      const reqUrl = url + "/fleet_customer/" + deleteId;
      const token = window.localStorage.getItem("token");
      const headers = { authorization: `bearer ${token}` };
      const { data } = await axios.delete(reqUrl, { headers });
      toast.success(data.message, { autoClose: 3000 });
      setReloadTable(1 + Math.random());
    } catch (error) {
      toast.error(error?.response?.data?.message || error.message, {
        autoClose: 3000,
      });
    } finally {
      setDeleteId(null);
    }
  }

  const options = [
    {
      header: "Name",
      key: "name",
      width: "15%",
    },
    {
      header: "Email",
      key: "email",
      width: "15%",
    },
    {
      header: "Payment Terms",
      key: "paymentTerms",
      width: "15%",
    },
    {
      header: "Credit Limit",
      key: "creditLimit",
      filterKey: "creditLimit",
      render: (data) => {
        return `$${formatNumberToUs(data.creditLimit?.toFixed(2))}`;

      },
      width: "15%",
    },
    {
      header: "Credit Balance",
      key: "creditBalance",
      render: (data) => {
        return `$${formatNumberToUs(data.creditBalance?.toFixed(2))}`;
      },
      width: "10%",
    },
    {
      header: "Bypass Approval",
      key: "bypassApproval",
      width: "10%",
    },
    {
      header: "Action",
      width: "20%",
      render: (data) => {
        return (
          <div className=''>
            <button
              className={"bg-customOne p-2 rounded-full mr-4"}
              onClick={(e) => {
                e.stopPropagation();
                toggleModify(data);
              }}
            >
              <img alt={"edit"} src={edit} height={15} width={15} />
            </button>
            <button
              className={"bg-customOne p-2 rounded-full mr-4"}
              onClick={(e) => {
                e.stopPropagation();
                setDeleteId(data.id);
              }}
            >
              <img alt={"delete"} src={deleteIcon} height={15} width={15} />
            </button>
          </div>
        );
      },
    },
  ];

  const excludeFilter = [
    "Action",
    "Status",
    "Credit Balance",
    "Bypass Approval",
  ];

  return (
    <div className='p-4'>
      {deleteId && (
        <ConfirmationModal
          title={"Fleet Customer"}
          setShowForm={setDeleteId}
          confirm={deleteFleet}
        />
      )}
      {showAddFleet && (
        <AddFleetCustomer
          otherData={otherData}
          setOtherData={setOtherData}
          setShowModal={setShowAddFleet}
          reload={setReloadTable}
          countryConfig={countryConfig}
        />
      )}

      {viewData && (
        <AddFleetCar viewData={viewData} setViewData={setViewData} cars={cars} importRowLimit={importRowLimit} />
      )}
      <div className='flex justify-between items-center mb-4'>
        <div className={title}>Fleet Customer</div>
        {
          <div className="flex flex-row">
            <Button
              className={`${btnOneNoWidth} mr-2`}
              clickHandler={() => setShowImportModal(true)}
              name='Import'
            />
            <Button
              className={`${btnOneNoWidth}`}
              name={`Add Fleet Customer`}
              clickHandler={() => {
                setShowAddFleet(!showAddFleet);
                setOtherData(undefined);
              }}
            />
          </div>
        }
      </div>
      {showImportModal &&
        <ImportModal setShowModal={setShowImportModal} downloadExcel={downloadExcel} handleFileUpload={handleFileUpload} type={"customer"} />
      }
      <Table
        options={options}
        url={url + "/fleet_customer"}
        pagination
        clickHandler={() => setShowAddFleet(!showAddFleet)}
        btnTitle={"Fleet Customer"}
        excludeFilter={excludeFilter}
        reloadTable={reloadTable}
        noButton={true}
        setViewData={setViewData}
      />
    </div>
  );
}

export default Fleet;
